import getModelsPerRow from './getModelsPerRow'

// Widest first, as `sizes` takes the first matching media condition. The min-widths are the
// $grid-breakpoints the `columns()` mixins in components/_card-3d-model.scss key on.
const BREAKPOINT_MIN_WIDTHS = [
  ['xxl', 1920],
  ['xl', 1600],
  ['lg', 1280],
  ['md', 960],
  ['sm', 640],
]

const columnWidth = (breakpoint, cardSizeSetting) => (
  `${parseFloat((100 / getModelsPerRow(breakpoint, cardSizeSetting)).toFixed(2))}vw`
)

// Card width as a `sizes` attribute for the given density setting. The grid is full-bleed, so a
// card is a fraction of the viewport; gutters are ignored, which only ever rounds up.
function getCardImageSizes(cardSizeSetting) {
  const entries = BREAKPOINT_MIN_WIDTHS.map(([breakpoint, minWidth]) => ({
    minWidth,
    width: columnWidth(breakpoint, cardSizeSetting),
  }))

  // A breakpoint that renders the same column count as the next narrower one adds nothing: the
  // narrower min-width already covers it.
  const distinct = entries.filter((entry, index) => entry.width !== entries[index + 1]?.width)

  return [...distinct.map(({ minWidth, width }) => `(min-width: ${minWidth}px) ${width}`), '100vw'].join(', ')
}

export default getCardImageSizes
